import { useState } from 'react'

import { t } from 'i18next'

import { Icon } from '@/components/icon'
import { Button, SheetDescription, SheetFooter, SheetHeader, SheetTitle } from '@/components/ui'
import { CheckboxGroup, CheckboxGroupItem } from '@/components/ui/checkbox-group'
import type { TVagasSelecionadas } from '@/features/proposta/interfaces/proposta.type'
import type { TPropostaSchemaInput } from '@/features/proposta/schemas'

type TVagaPadraoAcessoriosExtrasProps = {
  acessorios: Array<TPropostaSchemaInput['informacoesIniciais']['simulacoesAcessorios'][number]['produto']>
  onConfirmar: (selectedVagas: TPropostaSchemaInput['informacoesIniciais']['vagaIds']) => void
  handleGoBack: () => void
  defaultSelecionadas: TVagasSelecionadas
}

export const VagaPadraoAcessoriosExtras = ({
  acessorios,
  onConfirmar,
  handleGoBack,
  defaultSelecionadas = [],
}: TVagaPadraoAcessoriosExtrasProps) => {
  const [vagasSelecionadas, setVagasSelecionadas] = useState<string[]>(
    defaultSelecionadas.map((vaga) => String(vaga.id)),
  )

  const handleConfirmarSelecao = () => {
    onConfirmar(
      acessorios
        .filter((acessorio) => vagasSelecionadas.includes(String(acessorio.idExterno)))
        .map((vaga) => ({
          id: vaga.idExterno,
          nomeVaga: 'Acessorio',
          descricao: vaga.codigo,
          substituiVagaPadrao: true,
        })),
    )
  }

  return (
    <>
      <SheetHeader className="box-border max-w-137 gap-2 p-0 pt-9">
        <Button
          onClick={handleGoBack}
          variant="ghost"
          className="fit-content text-primary hover:text-primary/70 flex w-fit p-0 hover:bg-transparent [&_svg]:size-6"
        >
          <Icon name="arrow-left" />
          <p className="hidden text-base font-medium sm:block">{t('common:voltar')}</p>
        </Button>
        <SheetTitle className="text-2xl font-normal text-neutral-700 uppercase">
          {t('proposta:informacoes_iniciais.cards.vaga_padrao.acessorios_extras.titulo')}
        </SheetTitle>
        <SheetDescription className="m-w-137 text-base text-neutral-500">
          {t('proposta:informacoes_iniciais.cards.vaga_padrao.acessorios_extras.descricao')}
        </SheetDescription>
      </SheetHeader>
      <div>
        <CheckboxGroup className="grid gap-4" value={vagasSelecionadas} onValueChange={setVagasSelecionadas}>
          {acessorios.map((acessorio) => (
            <CheckboxGroupItem
              key={acessorio.idExterno}
              value={String(acessorio.idExterno)}
              id={String(acessorio.idExterno)}
              label={acessorio.codigo}
            />
          ))}
        </CheckboxGroup>
      </div>
      <SheetFooter className="fixed right-0 bottom-0 left-0 bg-white p-4 shadow-[0_-2px_10px_0_rgba(0,0,0,0.1)] sm:relative sm:grid sm:p-0 sm:py-4 sm:shadow-none">
        <Button
          variant="default"
          onClick={handleConfirmarSelecao}
          className="w-fit w-full justify-self-end aria-[disabled=true]:pointer-events-none sm:w-fit"
        >
          {t('proposta:informacoes_iniciais.cards.vaga_padrao.trigger.confirmar')}
        </Button>
      </SheetFooter>
    </>
  )
}
